<template>
  <div class="l-safe">
    <img :src="image">
    <p class="t-sans">Ware operates a Rave Safe policy - if you find yourself feeling uncomfortable, please speak to a member of the team and they will assist you.</p>
  </div>
</template>
<script>
export default {
  name: 'SafetyNotice',
  data: function () {
    return {
      image: require('@/assets/images/ravesafe.png')
    }
  }
}
</script>
<style scope lang="scss">
.l-safe {
  color: #fff;
  background: rgba(0,0,0,1);
  margin: 40px;
  font-size: 0.8rem;
  align-items: center;
  border-radius: 20px;
  display: inline-flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  padding: 10px 20px;
  p {
    padding-left: 5px;
  }
  img {
    margin: auto 0px;
    width:30%;
    height:30%;
    flex-grow: 2;
    padding: 10px 20px 10px 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SafetyNotice.vue